import type { GridsterEngine } from './gridster-engine';
import { GridsterItemConfig } from '../types';

export class GridsterRenderer {
  constructor(private gridster: GridsterEngine) {}

  updateItem(el: HTMLElement, item: GridsterItemConfig): void {
    const options = this.gridster.options;
    const x = Math.round(this.gridster.curColWidth * item.x);
    const y = Math.round(this.gridster.curRowHeight * item.y);
    const width = this.gridster.curColWidth * item.cols - options.margin;
    const height = this.gridster.curRowHeight * item.rows - options.margin;

    this.setCellPosition(el, x, y);
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;

    const marginBottom =
      this.gridster.rows === item.rows + item.y
        ? `${options.outerMarginBottom ?? options.margin}px`
        : '';
    const marginRight =
      this.gridster.columns === item.cols + item.x
        ? `${options.outerMarginRight ?? options.margin}px`
        : '';

    el.style.marginBottom = marginBottom;
    el.style.marginRight = marginRight;
  }

  setCellPosition(el: HTMLElement, x: number, y: number): void {
    el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
  }

  clearCellPosition(el: HTMLElement): void {
    el.style.transform = '';
  }
}
